import { GET_VENDOR_ACCOUNTS, GET_VENDOR_USERS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type vendorAccount = {
  vendorAccountId: string;
  associatedDomainName: string;
  externalUserId: string;
  isActive: boolean | null;
  isUsed: boolean | null;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const vendorAccountInitialValues: vendorAccount = {
  vendorAccountId: "",
  associatedDomainName: "",
  externalUserId: "",
  isActive: null,
  isUsed: null,
  created_at: [null, null],
  updated_at: [null, null],
};

export const vendorAccountMandatoryFields = [];

export const vendorAccountValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const vendorAccountProperties = [
  
  {
    id: "vendorAccountId",
    type: "single-select-search",
    label: "Vendor Account",
    // list: "vendor_accounts_gq",
    keyValue: { label: "associatedDomainName", value: "id" },
    query: GET_VENDOR_ACCOUNTS,
    gqlKey: "getVendorAccounts",
    dataKey: "vendorAccounts",
    searchFieldKey: "associatedDomainName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "associatedDomainName",
    type: "text",
    label: "Domain Name",
    Placeholder: "Enter Domain Name",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "externalUserId",
    type: "text",
    label: "External User ID",
    Placeholder: "Enter External User ID",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "isActive",
    type: "normal-select",
    label: "Is Active",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: false,
  },
  {
    id: "isUsed",
    type: "normal-select",
    label: "Is Used",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: false,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj: any, keys: any[]) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every((v) => v === null))
    );
  });
}
